import PaymentFormFinance from './Finance';
import PaymentFormOpenBanking from './OpenBanking';
import usePaymentForm from './usePaymentForm';

const PaymentForm: React.FunctionComponent = function () {
  const { paymentType, formRef } = usePaymentForm();
  if (!paymentType) return null;
  return (
    <>
      <div className="mb-6 md:mb-8" ref={formRef} />
      {paymentType === 'OPEN_BANKING' && <PaymentFormOpenBanking />}
      {paymentType === 'FINANCE' && <PaymentFormFinance />}
    </>
  );
};

export default PaymentForm;
